import { fromJS } from 'immutable'

import { forceImmutable } from '../util/immutableUtils'
import { WikiMarkupTransformer } from '@atlaskit/editor-wikimarkup-transformer';
import { ADFEncoder } from '@atlaskit/renderer';


const adfEncoder = new ADFEncoder( () => new WikiMarkupTransformer())

import { getAllRequestTypes, getRequestType, setRequestType,
    getAllUserIssues, getIssue, createIssue, updateIssue,
    setIssue, /*setEditable,*/ getIssueComments, updateIssueComment,
    addIssueComment, updateIssueData, clearNewIssueKey, setIssueError, clearIssues } from './actions'

let defaultState = fromJS({
    requestTypes: [],
    requestType: null,
    requestTypeName: null,
    issues: [],
    issue: null,
    issueComments: [],    
    issueUpdated: false,
    editable: false,    
})

export default function serviceDesk(state = defaultState, action) {
    state = forceImmutable(state) // Force immutable in case of rehydration

    switch (action.type) {
        case clearNewIssueKey.type:
            state = state.set('newIssueKey', null)
            return state
        case clearIssues.type:
            return state.set('issues', [])
        case setRequestType.type:
            return state.set('requestType', action.payload)
        case setIssue.type:
            return state.set('issue', action.payload)
        case updateIssueData.type:
            let {issue, values } = action.payload
            return state.set('issue', {...issue, ...values})
        /*case setEditable.type:
            return state.set('editable', action.payload)*/
        case getAllRequestTypes.event.success:
            state = state.set('requestTypes', action.payload)
            return state
        case getRequestType.event.success:
            state = state.set('requestType', action.payload)
            return state
        case getAllUserIssues.event.success:
            let { userIssues, searchResults, refresh } = action.payload
            let issueList = searchResults.issues
            state = state.set('totalIssues', searchResults.total)
            let processedIssueList = issueList.map(issue => {
                return process_issue(issue)
            })
            userIssues = userIssues.length && !refresh ? userIssues.concat(processedIssueList) : processedIssueList
            state = state.set('issues', userIssues)
            return state
        case getIssue.event.success:            
            state = state.set('issue', process_issue(action.payload.issues[0]))
            return state
        case setIssueError.type:
            state = state.set('issueError', action.payload)
            return state
        case createIssue.event.success:
            let { newIssue, issues, issueCount } = action.payload
            state = state.set('issue', process_issue(newIssue))
            state = state.set('newIssueKey', newIssue.key)
            issues.unshift(newIssue)
            state = state.set('totalIssues', issueCount + 1)
            state = state.set('issues', issues)            
            return state
        case updateIssue.event.success:
            let {response, issues_list } = action.payload
            state = state.set('issueUpdated', true)
            let updatedIssue = process_issue(response)
            state = state.set('issue', updatedIssue)
            state = state.set('issues', issues_list.map(issue => {
                if (issue.key === updatedIssue.key ) {
                    issue = updatedIssue
                }
                return issue
            }))            
            return state
        case getIssueComments.event.success:
            let { issueComments, user, jiraUser } = action.payload
            return state.set('issueComments', issueComments.map(comment => {                
                return portalfy_comments(user, jiraUser, comment)
            }))             
        case updateIssueComment.event.success:
            let { updatedComment, commentsList, requestor, jUser } = action.payload
            return state.set('issueComments', commentsList.map(comment => {
                return comment.id === updatedComment.id ? portalfy_comments(requestor, jUser, updatedComment) : comment}))
        case addIssueComment.event.success:
            let { newComment, comments, commentAuthor, JiraUser } = action.payload
            comments.push(portalfy_comments(commentAuthor, JiraUser, newComment))
            return state.set('issueComments', comments)
        default:
            return state

    }
}

function portalfy_comments(adUser, jiraUser, comment) {
    const checkString = 'Portal Comment made by: '
    let stripString = checkString + adUser.displayName
    if (comment.body.includes(checkString) ) {
        let commentWritter = comment.body.split(checkString).pop()
        let extraText = commentWritter.split(adUser.displayName)
        extraText ? commentWritter = commentWritter.replace(extraText, '') : null        
        if (commentWritter == adUser.displayName) {
            if (jiraUser) {
                jiraUser.avatarUrls ? comment.author.avatarUrls['48x48'] = jiraUser.avatarUrls['48x48'] : comment.author.avatarUrls = null;
                comment.author.displayName = jiraUser.displayName
                comment.author.emailAddress = jiraUser.emailAddress
            } else {
                comment.author.avatarUrls = null;
                comment.author.displayName = aduser.displayName
                comment.author.emailAddress = aduser.email
            }
        }
    }
    comment.body = comment.body.replace(stripString, '')
    comment.body = encode_wikiMarkup(comment.body, comment.mentions)
    return comment
}

function process_issue(issue) {    
    issue.requestType.inputs.properties.map(field => {
        if (field.type == 'wiki' || field.jiraFieldName =='description') {
            issue[field.id] = encode_wikiMarkup(issue[field.id], issue['mentions'])
        }
    })
    return issue
}

function encode_wikiMarkup(value, mentions) {    
    let doc = value ? adfEncoder.encode(value) : null    
    doc.content = parseDocForMentions(doc.content, mentions)
    return doc
}

function parseDocForMentions(contents, mentions) {
    for(var i = 0; i < contents.length; i++) {
        let object = contents[i]
        let array = object.content
        if (object.type === 'mention'){
            if (object.attrs.text === '') {
                for(var n = 0; n < mentions.length; n++) {
                    let mention = mentions[n]
                    if (object.attrs.id === mention.id && object.attrs.text === '') {
                        object.attrs.text = mention.text
                        break
                    }
                }                
            }
        }
        else if('content' in object) {
            object.content = parseDocForMentions(array, mentions)
        }
        contents[i] = object
    }        
    return contents
}

export const selectRequestTypes = state => state.serviceDesk.get('requestTypes')
export const selectRequestType = state => state.serviceDesk.get('requestType')
export const selectRequestTypeName = state => state.serviceDesk.get('requestTypeName')
export const selectIssues = state => state.serviceDesk.get('issues')
export const selectIssue = state => state.serviceDesk.get('issue')
export const selectIssueComments = state => state.serviceDesk.get('issueComments')
export const selectIssueFields = state => state.serviceDesk.get('fields')
export const selectNewIssueKey = state => state.serviceDesk.get('newIssueKey')
export const selectUpdateIssueStatus = state => state.serviceDesk.get('issueUpdated')
//export const selectEditable = state => state.serviceDesk.get('editable')
export const selectEditComment = state => state.serviceDesk.get('editComment')
export const selectComment = state => state.serviceDesk.get('comment')
export const selectEditingComment = state => state.serviceDesk.get('editingComment')
export const selectIssueError = state => state.serviceDesk.get('issueError')
export const selectIssuesTotal = state => state.serviceDesk.get('totalIssues')


// WEBPACK FOOTER //
// ./client/src/serviceDesk/reducer.js